

import React, { useState,useEffect } from "react";
import logo from "../img/Picture1.png"; // Update this path with your actual logo path
import AdvertisementShow from "./Advertisment";

const JobPortal = () => {
  const [filter, setFilter] = useState("All");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1); // Tracks the total pages
  const [loading, setLoading] = useState(false);
  const [jobs, setJobs] = useState([]);


  // const jobs = [
  //   {
  //     id: 1,
  //     date: "4 Feb, 2023",
  //     title: "Junior UI/UX Designer",
  //     tags: ["Experience","5-6 LPA", "Mode","Junior level", "Distant", "Project work", "Flexible Schedule"],
  //     description: "This is the detailed description of the Junior UI/UX Designer position.",
  //   },
  //   {
  //     id: 2,
  //     date: "10 Jan, 2023",
  //     title: "Backend Developer",
  //     tags: ["Mid level", "Onsite", "Full-time", "Competitive Salary"],
  //     description: "This is the detailed description of the Backend Developer position.",
  //   },
  //   {
  //     id: 3,
  //     date: "15 Mar, 2023",
  //     title: "Frontend Developer",
  //     tags: ["Senior level", "Remote", "Part-time", "Equity"],
  //     description: "This is the detailed description of the Frontend Developer position.",
  //   },
  //   {
  //     id: 4,
  //     date: "1 Apr, 2023",
  //     title: "Project Manager",
  //     tags: ["Mid level", "Hybrid", "Full-time", "Great Benefits"],
  //     description: "This is the detailed description of the Project Manager position.",
  //   },
  //   {
  //     id: 5,
  //     date: "20 May, 2023",
  //     title: "Data Scientist",
  //     tags: ["Expert level", "Remote", "Contract", "High Pay"],
  //     description: "This is the detailed description of the Data Scientist position.",
  //   },
  //   {
  //     id: 6,
  //     date: "30 June, 2023",
  //     title: "QA Engineer",
  //     tags: ["Junior level", "Onsite", "Internship", "Training Provided"],
  //     description: "This is the detailed description of the QA Engineer position.",
  //   },
  //   {
  //       id: 7,
  //       date: "30 June, 2023",
  //       title: "fronted Developer",
  //       tags: ["Junior level", "Onsite", "Internship", "Training Provided"],
  //       description: "This is the detailed description of the QA Engineer position.",
  //     },
  //     {
  //       id: 8,
  //       date: "30 June, 2023",
  //       title: "QA Engineer",
  //       tags: ["Junior level", "Onsite", "Internship", "Training Provided"],
  //       description: "This is the detailed description of the QA Engineer position.",
  //     },
  // ];

  const openModal = async (jobId) => {
    try {
      const response = await fetch(`http://10.10.20.9:7071/IIA-Website-1.0.0/jobpostings/getdata/${jobId}`);
      if (response.ok) {
        const data = await response.json();
        setSelectedJob(data); // Set the fetched job data
        setIsModalOpen(true); // Open the modal
      } else {
        console.error("Failed to fetch job details.");
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
    }
    // setSelectedJob(job);
    setIsModalOpen(true);
  };
  const closeModal = () => setIsModalOpen(false);

  // const filteredJobs = filter === "All" ? jobs : jobs.filter((job) => job.tags.includes(filter));



  const fetchWithTimeout = async (url, options = {}, timeout = 5000) => {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    
    const response = await fetch(url, { ...options, signal: controller.signal });
    clearTimeout(id);
    return response;
  };
  
  const fetchJobs = async (page = 1) => {
    setLoading(true);
    try {
      const response = await fetchWithTimeout(
        `http://10.10.20.9:7071/IIA-Website-1.0.0/jobpostings/getall/${page}`
      );
      const data = await response.json();
      
      setJobs(data);
      setTotalPages(Math.ceil(data.total / data.limit));
      
      const nextPage = page + 1;
      const responseNextPage = await fetchWithTimeout(
        `http://10.10.20.9:7071/IIA-Website-1.0.0/jobpostings/getall/${nextPage}`
      );
      const dataNextPage = await responseNextPage.json();
      
      if (dataNextPage  && dataNextPage.length > 0) {
        console.log(`Page ${nextPage} exists, fetching next jobs.`);
        setTimeout(() => {
          fetchJobs(nextPage);
        }, 100);
      } else {
        console.log(`Page ${nextPage} does not exist.`);
      }
    } catch (error) {
      console.error("Failed to fetch jobs:", error);
    }
    setLoading(false);
  };
  
  
  
  // Use useEffect to log jobs whenever they are updated
  useEffect(() => {
    console.log("Updated Jobs:", jobs);
  }, [jobs]); // This will log the jobs every time they are updated
  
  
  // To verify the updated jobs data, use a useEffect
 
  
  useEffect(() => {
    fetchJobs();
  },);

  const filteredJobs = 
  filter === "All"
    ? jobs // Show all data without filtering
    : (jobs || []).filter((job) =>
        job?.workMode?.toLowerCase() === filter?.toLowerCase()
      );



      if (filteredJobs && filteredJobs.length > 0) {
        // alert()
        filteredJobs.forEach((job) => {
          console.log("Job ID:", job.jobId); // Log jobId of each filtered job
        });
      } else {
        console.log("No jobs found for the given filter.");
      }
      

      const handleScroll = () => {
        if (
          window.innerHeight + document.documentElement.scrollTop >=
            document.documentElement.offsetHeight - 200 &&
          !loading &&
          currentPage < totalPages
        ) {
          setCurrentPage((prevPage) => prevPage + 1); // Increment page number
        }
      };
    
      useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
      }, [loading, currentPage, totalPages]);
    

  return (
    <div style={{marginRight:'300px'}}>

<div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px", // Adds space between the buttons
    marginTop: "156px",
  }}
>
  {/* <button
    className="category-btn"
    style={{
      fontFamily: "Roboto",
      fontSize: "20px",
      border: "1px solid transparent",
      borderRadius: "20px",
      backgroundColor: "blue",
      color: "white",
      width: "290px",
      height: "50px",
    }}
  >
    MECHANICAL ENGINEERING
  </button>

  <button
    className="category-btn"
    style={{
      fontFamily: "Roboto",
      fontSize: "20px",
      border: "1px solid transparent",
      borderRadius: "20px",
      backgroundColor: "blue",
      color: "white",
      width: "290px",
      height: "50px",
    }}
  >
    INFORMATION TECHNOLOGY
  </button> */}
</div>

   
    <div style={{ display: "flex", padding: "20px", margin: "0 auto", }}>
        
        <div className="categories">
       
      </div>
      
      {/* Sidebar */}
      <div
        style={{
          width: "250px",
          height:'446px',
          marginRight: "20px",
          padding: "20px",
          backgroundColor: "#f7f7f7",
          borderRadius: "8px",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h4>Filter Jobs</h4>
        <button
          onClick={() => setFilter("All")}
          style={{
            display: "block",
            width: "100%",
            padding: "10px",
            margin: "10px 0",
            border: "none",
            borderRadius: "5px",
            backgroundColor: filter === "All" ? "blue" : "#e0e0e0",
            color: filter === "All" ? "#fff" : "#000",
            cursor: "pointer",
          }}
        >
          All
        </button>
        <button
          onClick={() => setFilter("Remote")}
          style={{
            display: "block",
            width: "100%",
            padding: "10px",
            margin: "10px 0",
            border: "none",
            borderRadius: "5px",
            backgroundColor: filter === "Remote" ? "blue" : "#e0e0e0",
            color: filter === "Remote" ? "#fff" : "#000",
            cursor: "pointer",
          }}
        >
          Remote
        </button>
        <button
          onClick={() => setFilter("Hybrid")}
          style={{
            display: "block",
            width: "100%",
            padding: "10px",
            margin: "10px 0",
            border: "none",
            borderRadius: "5px",
            backgroundColor: filter === "Hybrid" ? "blue" : "#e0e0e0",
            color: filter === "Hybrid" ? "#fff" : "#000",
            cursor: "pointer",
          }}
        >
          Hybrid
        </button>
        <button
          onClick={() => setFilter("Work_From_Office")}
          style={{
            display: "block",
            width: "100%",
            padding: "10px",
            margin: "10px 0",
            border: "none",
            borderRadius: "5px",
            backgroundColor: filter === "Work_From_Office" ? "blue" : "#e0e0e0",
            color: filter === "Work_From_Office" ? "#fff" : "#000",
            cursor: "pointer",
          }}
        >
          Onsite
        </button>
      </div>

      {/* Cards Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "15px",
          flex: 1,
        }}
      >
         {filteredJobs?.map((job) => (
          <div
            key={job.id}
            style={{
              backgroundColor: "#d7f6ec",
              padding: "15px",
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                color: "blue",
                backgroundColor: "white",
                borderRadius: "8px",
                padding: "5px 10px",
                marginBottom: "15px",
              }}
            >
              <p>{job.postingDate}</p>
            </div>

            <img
              src={logo}
              alt="Logo"
              style={{
                width: "120px",
                height: "60px",
                objectFit: "contain",
                marginBottom: "10px",
              }}
            />

            <h4 style={{fontSize:'14px'}}>{job.jobTitle}</h4>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "5px",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              
                <span
                
                  style={{
                    backgroundColor: "#fff",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {job.ctcRange}
                </span>


                <span
                
                style={{
                  backgroundColor: "#fff",
                  padding: "5px 10px",
                  borderRadius: "5px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                {job.location}
              </span>
        
            </div>

            <button
              style={{
                backgroundColor: "#000",
                color: "#fff",
                padding: "10px 15px",
                border: "none",
                borderRadius: "5px",
                marginTop: "15px",
                cursor: "pointer",
              }}
              onClick={() => openModal(job.jobId)}
            >
              Details
            </button>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && selectedJob && (
        <div
            style={{
              position: 'fixed',
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Overlay
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={closeModal} // Close modal when clicking outside
          >
            <div
              style={{
                backgroundColor: '#fff',
                padding: '20px',
                borderRadius: '8px',
                width: '80%',
                maxWidth: '600px',
                position: 'relative',
              }}
              onClick={(e) => e.stopPropagation()} // Prevent closing modal when clicking inside it
            >
              {/* Date and Logo Section */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column', // Stack date and logo vertically
                  marginBottom: '20px',
                }}
              >
                {/* Date */}
                <div
                  style={{
                    color: 'blue',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    padding: '10px 20px',
                    textAlign: 'center',
                  }}
                >
                  <p>{selectedJob.postingDate}</p>
                </div>
        
                {/* Logo */}
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '10px' }}>
                  <img
                    src={logo}
                    alt="Logo"
                    style={{
                      width: '162px', // Adjust the width as needed
                      height: '80px', // Adjust the height as needed
                      objectFit: 'contain',
                    }}
                  />
                </div>
              </div>
        
              {/* Description */}
              <h3>Job Description</h3>
              <p>
              {selectedJob.jobDescription}
              </p>
        
              {/* Scrollable List */}
              <div
          style={{
            maxHeight: '200px', // Set the max height of the container
            overflowY: 'auto', // Enable vertical scrolling
            paddingRight: '10px', // Optional, to avoid content touching the scrollbar
            textAlign: 'left', // Align text to the left
          }}
        >
          <div className="job-details" style={{ alignItems:'flex-start'}}>
            {/* <h4 >Job Title: <span>Software Engineer</span></h4> */}
            <p>Role: <span>{selectedJob.jobRole}</span></p>
            <p>Experience: <span>{selectedJob.experience}</span></p>
            <p>CTC: <span>{selectedJob.ctcRange}</span></p>
            <p>Location: <span>{selectedJob.location}</span></p>
            <p>Company: <span>{selectedJob.organisation}</span></p>
            {/* <p>Description: <span>{selectedJob.jobDescription}</span></p> */}
            <p>Skills Required: <span>{selectedJob.skillsRequired}</span></p>
          </div>
        
          <button 
            style={{
              backgroundColor: 'blue',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              textAlign: 'center',
              display: 'block',
              margin: '20px auto',
              fontSize: '16px',
              cursor: 'pointer',
              borderRadius: '5px'
            }} 
            onMouseOver={(e) => e.target.style.backgroundColor = 'darkblue'} 
            onMouseOut={(e) => e.target.style.backgroundColor = 'blue'}
          >
            Enquiry Now
          </button>
        </div>
        
        
              {/* Card-like Details */}
              
        
                   
                </div>
              </div>
             )}

    </div>
    <AdvertisementShow/>
    </div>
   
  );
  
};





export default JobPortal;



